import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class PrizeQueryFilter extends QueryFilter {
    public outingIterationId: string;
}